import { ListTodo, Clock, AlertTriangle, Calendar } from 'lucide-react'
import { StatsCard } from './StatsCard'
import { Skeleton } from '@/components/ui'
import type { DashboardStats } from '@/hooks'

interface StatsGridProps {
  stats: DashboardStats
  isLoading?: boolean
}

export function StatsGrid({ stats, isLoading }: StatsGridProps) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {[...Array(4)].map((_, i) => (
          <Skeleton key={i} className="h-[120px] rounded-xl animate-shimmer" />
        ))}
      </div>
    )
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <StatsCard
        title="Tasks Due Today"
        value={stats.tasksDueToday}
        icon={ListTodo}
        description={stats.tasksDueToday === 0 ? 'No tasks due' : undefined}
      />
      <StatsCard
        title="Hours Logged Today"
        value={stats.hoursLoggedToday.toFixed(1)}
        icon={Clock}
        description="Today's tracked time"
      />
      <div className="relative">
        {stats.overdueTasks > 0 && (
          <span className="absolute top-2 right-2 z-10 h-2.5 w-2.5 rounded-full bg-destructive animate-glow-pulse" />
        )}
        <StatsCard
          title="Overdue Tasks"
          value={stats.overdueTasks}
          icon={AlertTriangle}
          alert={stats.overdueTasks > 0}
          description={stats.overdueTasks > 0 ? 'Needs attention' : 'All caught up'}
        />
      </div>
      <StatsCard
        title="Upcoming Deadlines"
        value={stats.upcomingDeadlines}
        icon={Calendar}
        description="Next 7 days"
      />
    </div>
  )
}
